<template lang="pug">
div
  div.d-flex.justify-center.mt-16(v-if="isFetching")
    v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
  template(v-else)
    stock-take-summary-mobile(v-if="$vuetify.breakpoint.mobile" :id="id")
    stock-take-summary-desktop(v-else :id="id")
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Cookies from 'js-cookie'
import StockTakeSummaryMobile from '@/components/clinic/inventory/stocktake/StockTakeSummaryMobile.vue'
import StockTakeSummaryDesktop from '@/components/clinic/inventory/stocktake/StockTakeSummaryDesktop.vue'

export default {
  name: 'StockTakeSummaryShare',
  components: { StockTakeSummaryMobile, StockTakeSummaryDesktop },
  props: ['id'],
  data () {
    return {
      isFetching: false,
      status: 'all'
    }
  },
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({
      company: 'getCompany',
      currency: 'getCompanyCurrency'
    }),
  },
  mounted () {
    this.setInit()
    this.setScreenSize()
  },
  methods: {
    ...mapActions(['showMessage']),
    setInit () {
      const cookieUser = Cookies.get('user')
      if (!cookieUser || !this.company) {
        this.$store.commit('ui/setRedirectPath', this.$route.path)
        this.goToSignIn()
        return
      }
      if (!this.user) {
        let user = JSON.parse(cookieUser)
        this.$store.commit('user/setUser', user)
      }
      if (!this.member) {
        let user = JSON.parse(cookieUser)
        this.fetchMember(user)
      }
      this.$store.commit('ui/setRedirectPath', null)
    },
    fetchMember (user) {
      this.isFetching = true
      this.$axios.get('/members/', { params: { user: user.id, company: this.company.id } })
        .then(resp => {
          if (resp.data.results.length === 0) {
            this.showMessage(['error', 'You do not have permission to view this link.'])
          } else {
            this.$store.commit('user/setMember', resp.data.results[0])
            this.isFetching = false
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    setScreenSize () {
      if (this.$vuetify.breakpoint.mobile) {
        this.$store.commit('ui/setDisplaySize', 'large')
      } else {
        this.$store.commit('ui/setDisplaySize', 'medium')
      }
    },
    goToSignIn () {
      if (this.$subdomain) {
        document.location.href = `https://${this.$subdomain}.${process.env.VUE_APP_BASE_DOMAIN}/signin`
      } else {
        this.$router.push('/signin')
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>